import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import CurrentPage from '@frontend/app/features/CurrentPage';
import { show, hide } from '@frontend/utils/dom';

export default class extends Controller {
  connect() {
    if (
      !CurrentPage.isArticlePreview() &&
      (CurrentUser.isEditor() || CurrentUser.isAdmin())
    ) {
      const isDismissed =
        sessionStorage.getItem('article-author-share-url-topbar-dimissed') ===
        'true';
      if (!isDismissed) {
        show(this.element);
      }
    }
  }

  dismiss() {
    sessionStorage.setItem('article-author-share-url-topbar-dimissed', 'true');
    hide(this.element);
  }
}
